export default __webpack_public_path__ + "68a16d1db6d32f2384ff5e236d1ea8b0.svg";